import { Carousel } from 'react-bootstrap'
import App1 from '../../../assets/images/App1.svg'
import App2 from '../../../assets/images/App2.svg'
import App3 from '../../../assets/images/App3.svg'
import App4 from '../../../assets/images/App4.svg'
import App5 from '../../../assets/images/App5.svg'
import App6 from '../../../assets/images/App6.svg'
import { useTranslation } from 'react-i18next';

const Content2Mobile = () => {
    const { t } = useTranslation()

    return (
        <div className="produkApp2">
            <h6 className="fw-bold fs-30 m-fs-16 lh-160 color-blue text-center text-lg-start text-md-start">{t('products.application.features.title')}</h6>
            <Carousel
                id='app'
                className='mt-3'
                nextIcon={null}
                prevIcon={null}
                interval={1000}
                style={{"height": "385px"}}
                >
                    {/* 1 */}
                    <Carousel.Item>
                        <div className='d-flex justify-content-center'>
                            <div className='imageApp'>
                                <img src={ App1 } className="mx-auto d-block mt-4" alt="Eureka" /> <br />
                                <div className='text-center dark-text fs-12 lh-160 fw-bold dark-text nowrap'>{t('products.application.features.feature1')}</div>
                            </div>
                        </div>
                    </Carousel.Item>
                    {/* 2 */}
                    <Carousel.Item>
                        <div className='d-flex justify-content-center'>
                            <div className='imageApp'>
                                <img src={ App2 } className="mx-auto d-block mt-4" alt="Eureka" /> <br />
                                <div className='text-center dark-text fs-12 lh-160 fw-bold dark-text nowrap'>{t('products.application.features.feature2')}</div>
                            </div>
                        </div>
                    </Carousel.Item>
                    {/* 3 */}
                    <Carousel.Item>
                        <div className='d-flex justify-content-center'>
                            <div className='imageApp'>
                                <img src={ App3 } className="mx-auto d-block mt-4" alt="Eureka" /> <br />
                                <div className='text-center dark-text fs-12 lh-160 fw-bold dark-text nowrap'>{t('products.application.features.feature3')}</div>
                            </div>
                        </div>
                    </Carousel.Item>
                    {/* 4 */}
                    <Carousel.Item>
                        <div className='d-flex justify-content-center'>
                            <div className='imageApp'>
                                <img src={ App4 } className="mx-auto d-block mt-4" alt="Eureka" /> <br />
                                <div className='text-center dark-text fs-12 lh-160 fw-bold dark-text'>{t('products.application.features.feature4')}</div> <br />
                            </div>
                        </div>
                    </Carousel.Item>
                    {/* 5 */}
                    <Carousel.Item>
                        <div className='d-flex justify-content-center'>
                            <div className='imageApp'>
                                <img src={ App5 } className="mx-auto d-block mt-4" alt="Eureka" /> <br />
                                <div className='text-center dark-text fs-12 lh-160 fw-bold dark-text nowrap'>{t('products.application.features.feature5')}</div>
                            </div>
                        </div>
                    </Carousel.Item>
                    {/* 6 */}
                    <Carousel.Item>
                        <div className='d-flex justify-content-center'>
                            <div className='imageApp'>
                                <img src={ App6 } className="mx-auto d-block mt-4" alt="Eureka" /> <br />
                                <div className='text-center dark-text fs-12 lh-160 fw-bold dark-text nowrap'>{t('products.application.features.feature6')}</div>
                            </div>
                        </div>
                    </Carousel.Item>
                </Carousel>
        </div>
    )
}

export default Content2Mobile